import { render, staticRenderFns } from "./PlayTable.vue?vue&type=template&id=5ce5d14e&scoped=true&"
import script from "./PlayTable.vue?vue&type=script&lang=js&"
export * from "./PlayTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayTable.vue?vue&type=style&index=0&id=5ce5d14e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5d14e",
  null
  
)

/* custom blocks */
import block0 from "./PlayTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports